import {
  drawerWidth,
  drawerMiniWidth,
  transition,
  containerFluid,
} from "assets/jss/material-dashboard-pro-react.js";

import backgroundImage from "assets/img/background_2.png";

/**
 * Altura real del top bar móvil.
 * Debe mantenerse alineada con el navbar móvil decorado.
 */
const MOBILE_TOPBAR_HEIGHT = 60;

const appStyle = (theme) => ({
  wrapper: {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "relative",
    top: 0,
    minHeight: "100vh",
    overflowX: "hidden",
    paddingBottom: "20vh",

    [theme.breakpoints.down("sm")]: {
      height: "auto",
      minHeight: "100vh",
      paddingBottom: theme.spacing(12),
    },

    "&:after": {
      display: "table",
      clear: "both",
      content: '" "',
    },
  },

  mainPanel: {
    position: "relative",
    float: "right",
    width: "100%",
    minHeight: "100vh",
    ...transition,

    [theme.breakpoints.up("md")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      height: "100vh",
      overflow: "auto",
    },

    [theme.breakpoints.down("sm")]: {
      overflowX: "hidden",
      overflowY: "visible",
      height: "auto",
      minHeight: "100vh",
    },
  },

  /**
   * El navbar móvil ahora es sticky y forma parte del flujo normal.
   * No hace falta compensar con márgenes artificiales,
   * pero sí dejamos respiración vertical razonable.
   */
  content: {
    padding: theme.spacing(3, 2),
    minHeight: "calc(100vh - 123px)",

    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2.5, 1.5, 2),
      minHeight: `calc(100vh - ${MOBILE_TOPBAR_HEIGHT}px - 72px)`,
    },

    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(2, 1, 1.5),
    },
  },

  container: {
    ...containerFluid,
    width: "100%",
    maxWidth: "100%",
    margin: "0 auto",

    [theme.breakpoints.down("sm")]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },

  /**
   * Ya no hay navbar absoluto superpuesto.
   * El mapa y el resto de vistas pueden empezar sin offset artificial.
   */
  map: {
    marginTop: 0,
    minHeight: "100vh",

    [theme.breakpoints.down("sm")]: {
      marginTop: 0,
      minHeight: `calc(100vh - ${MOBILE_TOPBAR_HEIGHT}px)`,
    },
  },

  mainPanelSidebarMini: {
    [theme.breakpoints.up("md")]: {
      width: `calc(100% - ${drawerMiniWidth}px)`,
    },
  },

  mainPanelWithPerfectScrollbar: {
    overflow: "hidden !important",
  },
});

export default appStyle;